<template>
	<div>
		<div class="pg-header">
			<div>
				<label class="title">问卷管理</label>
			</div>
			<div class="algr">
				<div class="pg-nav">
					<i class="icon-home"></i>
					<span>系统管理</span>|
					<span class="active">问卷管理</span>
				</div>
				<!-- <a class="back noline" @click="goBack">返回</a> -->
			</div>
		</div>

		<div class="table-wrap">
			<div class="search-bar">
				<div style="display: inline-block;">
					<label>问卷名称
						<el-input size="small" placeholder="问卷名称" clearable v-model.trim="filter.name" @keyup.enter.native="handleFilter(1)"></el-input>
					</label>
				</div>
				<div style="display: inline-block;">科室
					<el-select size="small" class="multiple-select" filterable multiple clearable collapse-tags v-model="filter.depId" placeholder="请选择" @change="handleFilter(1, $event)">
						<el-option v-for="item in deptList" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</div>
				<div style="display: inline-block;margin-left: 8px;">问卷类型
					<el-select size="small" class="multiple-select"  filterable clearable v-model="filter.type" placeholder="请选择" @change="handleFilter(1, $event)">
							<el-option label="随访问卷" value="0"></el-option>
							<el-option label="评估问卷" value="1"></el-option>
							<el-option label="院中其他问卷" value="3"></el-option>
							<el-option label="延续性护理服务问卷" value="4"></el-option>
					</el-select>
				</div>
				<el-button class="flr" size="mini" icon="el-icon-search" round @click="handleFilter(0)">搜索</el-button>
			</div>
			<div class="action-bar">
				<el-button type="primary" size="mini" round @click="showDlg">新增问卷</el-button>

				<!-- <el-popconfirm confirmButtonText='删除' title="确定批量删除吗？" @confirm="delItem">
					<el-button slot="reference" type="danger" size="mini" round plain>批量删除</el-button>
				</el-popconfirm> -->
			</div>
			<el-table ref="multipleTable" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border
				:data="list.data" v-loading="isLoading" @selection-change="selectionChange">
				<!-- <el-table-column fixed="left" type="selection" width="55"></el-table-column> -->
				<el-table-column prop="id" label="问卷id"></el-table-column>
				<el-table-column prop="name" label="问卷名称"></el-table-column>
				<el-table-column prop="sort" label="问卷排序"></el-table-column>
				<el-table-column prop="remark" label="备注"  show-overflow-tooltip></el-table-column>
				<el-table-column prop="type" label="问卷类型" width="200">
					<template slot-scope="scope">
						<span v-if="scope.row.type == 0">随访问卷</span>
						<span v-else-if="scope.row.type == 1">评估问卷</span>
						<span v-else-if="scope.row.type == 3">院中其他问卷</span>
						<span v-else-if="scope.row.type == 4">延续性护理服务问卷</span>
						<span v-else>未知类型</span>
					</template>
				</el-table-column>
				<el-table-column label="所属科室" show-overflow-tooltip>
					<template slot-scope="scope">
						<span v-if="scope.row.allDepartment==1">所有科室</span>
						<span v-else v-text="scope.row.depList?.map(item=>item.depName).join(', ')"></span>
					</template>
				</el-table-column>
				<el-table-column prop="questionnaireRuleJson" label="规则状态">
					<template slot-scope="scope">
						<span v-if="scope.row.questionnaireRuleJson != ''">已设置</span>
						<span style="color: red;" v-else>未设置</span>
					</template>
				</el-table-column>
				<el-table-column prop="date" label="更新记录时间" width="200"></el-table-column>
				<el-table-column fixed="right" label="操作" width="200">
					<template slot-scope="scope">
						<div class="tab-action">
							<!-- <el-tooltip content="查看" placement="top" :enterable="false"><router-link target='_blank' :to="{name: 'System/ScheduleTemplateView', query: {templateId: scope.row.id}}"><i class="icon-research"></i></router-link></el-tooltip> -->
							<el-tooltip content="修改" placement="top" :enterable="false"><i class="el-icon-edit-outline"
									@click="showDlg(scope.row)"></i></el-tooltip>
							<el-popconfirm confirmButtonText='删除' title="确定删除吗？" @confirm="delItem(scope.row)">
								<el-tooltip content="删除" slot="reference" placement="top" :enterable="false"><i
										class="el-icon-delete"></i></el-tooltip>
							</el-popconfirm>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination">
				<el-row>
					<el-col :span="12">
						<div class="record">当前是第<span v-text="(filter.pageNumber-1)*filter.pageSize+1"></span>条至第<span
								v-text="(filter.pageNumber-1)*filter.pageSize+filter.pageSize"></span>数据</div>
						<div class="record">总计<span v-text="list.total"></span>条记录</div>
					</el-col>
					<el-col :span="12" style="text-align: right;">
						<el-pagination :disabled="isLoading" layout="sizes, prev, pager, next"
							:page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]" prev-text="上一页" next-text="下一页"
							:current-page="list.current" :page-size="filter.pageSize" :total="list.total"
							@size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
					</el-col>
				</el-row>
			</div>
		</div>

		<el-dialog :title="form.id > 0 ? '修改问卷' : '新增问卷'" center :visible.sync="dlg.active"
			:close-on-click-modal="false">
			<div style="height: 34rem; overflow-y: auto;">
				<el-form ref="form" :rules="dlg.rules" :model="form">

					<el-form-item label="问卷名称" prop="name">
						<el-input v-model="form.name"></el-input>
					</el-form-item>

					<el-form-item label="问卷类型" prop="type">
						<el-select filterable clearable v-model="form.type" placeholder="请选择">
							<el-option label="随访问卷" value="0"></el-option>
							<el-option label="评估问卷" value="1"></el-option>
							<el-option label="院中其他问卷" value="3"></el-option>
							<el-option label="延续性护理服务问卷" value="4"></el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="问卷排序" prop="sort">
						<el-input-number v-model="form.sort"></el-input-number>
					</el-form-item>

					<el-form-item label="备注" prop="remark">
						<el-input v-model="form.remark"></el-input>
					</el-form-item>
					<el-form-item :class="form.allDepartment==1?'erroritem':'depitem'" label="科室权限" prop="depIds">
						<el-radio-group v-model="form.allDepartment" @change="changeDeps($event)">
							<el-radio :label="1">所有科室</el-radio>
							<el-radio :label="0">部分科室</el-radio>
						</el-radio-group>
						<!-- <el-cascader ref="depCascader" v-if="dlg.depActive" filterable :props="deptProps" v-model="dlg.form.depIds"></el-cascader> -->
						<el-select
								v-if="visible"
								class='selectItem'
								v-model="form.depIds"
								multiple
								filterable
								remote
								reserve-keyword
								placeholder="请输入关键词"
								:remote-method="remoteMethod"
								@change="$forceUpdate()"
								value-key="value"
								:loading="loading">
								<el-option
								v-for="item in options"
								:key="item.id"
								:label="item.label"
								:value="item.value">
								</el-option>
							</el-select>
					</el-form-item>
					<div style="margin-bottom: 20px; font-size: 14px; text-align: center;">问卷内容</div>
					<el-form-item label="内容" prop="questionnaireJson">
						<el-input type="textarea" v-model="form.questionnaireJson" :rows="5"></el-input>
					</el-form-item>

					<div style="margin-bottom: 20px; font-size: 14px; text-align: center;" v-if="form.id > 0">问卷规则</div>

					<el-form-item label="统计类型" v-if="form.id > 0">
						<el-select filterable clearable v-model="form.questionnaireRuleJson.type" placeholder="请选择">
							<el-option label="通用" value="0"></el-option>
							<el-option label="满意率" value="1"></el-option>
						</el-select>
					</el-form-item>

					<div v-for="(question,index) in form.questionnaireRuleJson.formItems" :key="question.formId">
						<h1 style="margin-bottom: 20px; font-size: 14px;color:#000;">第{{index+1}}题：{{question.label}}</h1>
						<el-form-item :label="option.label" v-for="option in question.options" :key="option.value">
							<div v-if="form.questionnaireRuleJson.type == '0'">
								<el-radio-group v-model="option.type">
									<el-radio :label="1">计次</el-radio>
									<el-radio :label="2">计分</el-radio>
								</el-radio-group>
							</div>
							<div v-else>
								<el-radio-group v-model="option.type">
									<el-radio :label="1">满意</el-radio>
									<el-radio :label="0">不满意</el-radio>
								</el-radio-group>
							</div>
						</el-form-item>
					</div>

				</el-form>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button type="primary" :loading="isLoading" @click="saveForm">保 存</el-button>
				</div>
			
		</el-dialog>


	</div>


</template>

<script>
	// import HelloWorld from '@/components/HelloWorld.vue'
	import mixin from '@/views/mixin';
	import api from '@/service/api.js';
	import dayjs from 'dayjs';

	export default {
		mixins: [mixin],
		data() {
			let checkDepIds=(rule, value, callback) => {
				if(this.form.allDepartment==0&&this.form.depIds.length==0){
					callback(new Error('请选择'));
				}else{
					callback();
				}
			};
			return {
				dlg: {
					active: false,
					rules: {
						name: {
							required: true,
							message: '请输入问卷名称',
							trigger: 'blur'
						},
						type: {
							required: true,
							message: '请选择问卷类型',
							trigger: 'change'
						},
						questionnaireJson: {
							required: true,
							message: '请输入问卷内容',
							trigger: 'blur'
						},
						depIds:{required: true, message: '请选择', trigger: ['change','blur','select'],
						validator:checkDepIds}
						}
				},
				list: {
					current: 1,
					total: 0,
					pageSize: 0,
					data: null
				},
				filter: {
					name: '',
					type: '',
					subtype: '',
					pageNumber: 1,
					pageSize: 10,
					depIds:'',
					depId:[]
				},
				form: {
					name: '',
					type: '',
					remark: '',
					questionnaireJson: '',
					questionnaireRuleJson: '',
					resultType: 1,
					sort: 0,
					allDepartment:1,
					depIds:''
				},
				deptList: [],
				questType:
				[{
					label: '随访',
					value: 0
				}, {
					label: '评估',
					value: 1
				}, {
					label: '院中(微信小程序)',
					value: 2
				}, {
					label: '院中(即将出院满意度调查)',
					value: 3
				}, {
					label: '患者(延续性护理服务)',
					value: 4
				}],
				depFilter:{
					departmentState:'',
					departmentType:'',
					id:'',
					name:'',
					orgId:'',
					pageNumber:1,
					pageSize:9999
				},
				loading:false,
				options:[],
				visible:false,//科室权限选择框
			}
		},
		created() {
			this.loadList();
			// 获取 科室下拉
			api.getListComboboxDep(this.depFilter).then((res)=>{
			if (res.code == 1000 && res.data) {
				this.deptList = res.data;
			}
		});
		},
		methods: {
			remoteMethod(query) {
				if (query !== '') {
					this.depFilter.name=query;
					this.loading = true;
					setTimeout(() => {
						api.getListComboboxDep(this.depFilter).then(res=>{
							this.loading = false;
							if (res.code == 1000 && res.data) {
								this.options=res.data.map(item=>{
									return { value: item.id, label: item.name,...item };
								})
							}
						})
					}, 200);
				} else {
					this.options = [];
				}
			},
			changeDeps(e){
				if(this.form.allDepartment==0){
					this.form.depIds='';
					setTimeout(() => {
						this.visible=true
					}, 300);
				}else{
					this.form.depIds=0;
					this.visible=false;
					this.options=[];
				}
				this.$forceUpdate()
			},
			async loadList() {
				this.isLoading = true;
				if (this.filter.depId) {
					this.filter.depIds = this.filter.depId.join(',');
				}
				let res = await api.getQuestiondictList(this.filter);
				if (res.code == 500) {
					return this.$router.push({
						name: 'Login',
						query: {
							r: location.href
						}
					});
				}
				this.list.total = +res.total;
				this.list.current = this.filter.pageNumber;
				this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
				if (res.data) {
					res.data.forEach((item) => {
						item.date = dayjs(item.updateTime).format('YYYY-MM-DD HH:mm:ss');
					})
					this.list.data = res.data;
				}
				this.isLoading = false;
			},
			showDlg(item) {
				this.dlg.active = true;
				this.options=[];

				if (item && item.id > 0) {
					this.$nextTick(async () => {
						let res = await api.getQuestiondictById(item.id);
						if (res.code == 500) {
							return this.$router.push({
								name: 'Login',
								query: {
									r: location.href
								}
							});
						}

						this.form = res.data;
						this.form.type = this.form.type.toString();
						let rule = JSON.parse(this.form.questionnaireRuleJson);
						rule.type = rule.type != undefined ? rule.type.toString() : '0';
						rule.formItems.map((item) => {
							item.options.map((option) => {
								option.type = option.type != undefined ? option.type : 1;
							})
						})
						this.form.questionnaireRuleJson = rule

						this.options=this.form.depList.map(item=>{
								return { value: item.depId, label: item.depName,...item };
							})
						this.form.depIds = this.form.depList.map(item =>{return parseInt(item.depId)});
						this.form.allDepartment=this.form.depList[0].depId!=0?0:1
						this.visible=this.form.depList[0].depId!=0?true:false;


						this.$refs['form'].resetFields();
					});
				} else {
					this.form.id = 0;
					this.form.resultType = 1;
					this.form.allDepartmen=1;
					this.form.questionnaireRuleJson = '';
					this.$nextTick(() => {
						this.$refs['form'].resetFields();
					});
				}
			},
			closeDlg() {
				this.dlg.active = false;
			},
			async saveForm() {
				let res;
				this.$refs['form'].validate(async (valid) => {
					if (valid) {
						if(this.form.depIds){
							this.form.depIds=this.form.depIds.join(',');
						}
						if (this.form.id > 0) {
							this.form.resultType = 0;
							this.form.questionnaireRuleJson = JSON.stringify(this.form
								.questionnaireRuleJson);
							res = await api.updateQuestiondictById(this.form);
						} else {
							res = await api.addQuestiondict(this.form);
						}
						if (res.code != 1000) {
							this.$message.error(res.message);
							return;
						}
						this.loadList();
						this.$message({
							message: '保存成功',
							type: 'success'
						});
						this.closeDlg();
					}
				})
			},
			async delItem(item) {
				let res;
				if (this.isLoading) {
					return;
				}

				this.isLoading = true;
				res = await api.delQuestiondictById(item.id);
				// if (item && item.id > 0) {
				// 	res = await api.delSysOrg(item.id);
				// } else {
				// 	// 批量删除
				// 	if (this.multipleSelection.length == 0) {
				// 		this.isLoading = false;
				// 		return this.$message.warning('未选择任何数据');
				// 	}
				// 	res = await api.delScheduleTemplate({ids: this.multipleSelection.join(',')});
				// }
				if (res.code != 1000) {
					this.isLoading = false;
					return this.$message.error(res.message);
				}
				this.isLoading = false;
				this.$message({
					message: '已删除',
					type: 'success'
				});
				this.loadList();
			},
			// 过滤条件 更改
			handleFilter(key, val) {
				this.filter.pageNumber = 1;
				this.loadList();
			},
			handleSizeChange(v) {
				this.filter.pageSize = v;
				this.filter.pageNumber = 1;
				this.loadList();
			},
			handleCurrentChange(v) {
				this.filter.pageNumber = v;
				this.loadList();
			}
		}
	}
</script>

<style lang="less" scoped>
	@import '@/assets/style/var';
	.selectItem{
		display: block;
		margin-left: 68px;
	}
	.multiple-select{
		/deep/ .el-input{
			width: 250px;
			margin:0;
		}
	}
	.erroritem{
	::v-deep .el-form-item__error{
		display: none !important;
	}
  }
	.el-form .el-textarea {
		width: 100%;
	}
</style>